<template>
  <p class="clearfix mb-0">
    <span class="float-xl-left d-none d-xl-block d-xl-inline-blockmt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://modv.io" target="_blank">My Own Document Vualt</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved v:{{ appVersion }}</span>
    </span>
    <span class="float-xl-right d-none d-xl-block"
      >Secure &amp; Made with
      <feather-icon icon="HeartIcon" size="21" class="text-danger stroke-current" />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink
  },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-bottom-navigation {
  background-color: red;
  height: 200px;
}
</style>
